import {createSlice, type PayloadAction} from '@reduxjs/toolkit';
import type {UpsellMode} from '~/common/fabric/UpsellModal/UpsellModal';
import type {EventFeature} from '~/common/types/event';

type ControllersState = {
  showCharityController: boolean;
  showCrowdfundController: boolean;
  showUpsellModal: boolean;
  featureToggling: EventFeature | null;
  upsellMode?: UpsellMode;
  inAdsToggle: boolean;
};

const INITIAL_STATE: ControllersState = {
  showCharityController: false,
  showCrowdfundController: false,
  showUpsellModal: false,
  featureToggling: null,
  inAdsToggle: false,
};

const controllersSlice = createSlice({
  name: 'controllers',
  initialState: INITIAL_STATE,
  reducers: {
    setShowCharityController: (state, action: PayloadAction<boolean>) => ({
      ...state,
      showCharityController: action.payload,
    }),
    setShowCrowdfundController: (state, action: PayloadAction<boolean>) => ({
      ...state,
      showCrowdfundController: action.payload,
    }),
    setShowUpsellModal: (state, action: PayloadAction<boolean>) => ({
      ...state,
      showUpsellModal: action.payload,
    }),
    setFeatureToggling: (state, action: PayloadAction<EventFeature | null>) => ({
      ...state,
      featureToggling: action.payload,
    }),
    setUpsellMode: (state, action: PayloadAction<UpsellMode | undefined>) => ({
      ...state,
      upsellMode: action.payload,
    }),
    setInAdsToggle: (state, action: PayloadAction<boolean>) => ({
      ...state,
      inAdsToggle: action.payload,
    }),
  },
  selectors: {
    selectShowCharityController: (state) => state.showCharityController,
    selectShowCrowdfundController: (state) => state.showCrowdfundController,
    selectShowUpsellModal: (state) => state.showUpsellModal,
    selectFeatureToggling: (state) => state.featureToggling,
    selectUpsellMode: (state) => state.upsellMode,
    selectInAdsToggle: (state) => state.inAdsToggle,
  },
});

export const controllersReducer = controllersSlice.reducer;
export const {
  setShowCharityController,
  setShowCrowdfundController,
  setShowUpsellModal,
  setFeatureToggling,
  setUpsellMode,
  setInAdsToggle,
} = controllersSlice.actions;
export const {
  selectShowCharityController,
  selectShowCrowdfundController,
  selectShowUpsellModal,
  selectFeatureToggling,
  selectUpsellMode,
  selectInAdsToggle,
} = controllersSlice.selectors;
